<app-common-page-breadcrumbs [navigationData]="navigationData" [pageTitle]="title"></app-common-page-breadcrumbs>

<div *ngIf="enableLoader" id="loader"></div>
    <div class="container py-4 d-flex w-100 justify-content-center">
        <form *ngIf="!enableLoader" [formGroup]="" #f="ngForm">
            <div class="form-group">
                <label for="formGroupExampleInput1">{{'heading.CompanyName' | cxTranslate}}</label>
                <input type="text" class="form-control form-control-lg" id="formGroupExampleInput1" value="{{i.name}}" disabled>
            </div>
            <div class="form-group">
                <label for="formGroupExampleInput2">{{'heading.RegisteredAddress' | cxTranslate}}</label>
            </div>
            <div class="form-group">
                <label for="formGroupExampleInput2">{{'heading.OfficeAddressLine1' | cxTranslate}}</label>
                <input type="text" class="form-control form-control-lg" id="formGroupExampleInput2" value="{{i.addresses[0].line2}}" disabled>
            </div>
            <div class="form-group">
                <label for="formGroupExampleInput3">{{'heading.OfficeAddressLine2' | cxTranslate}}</label>
                <input type="text" class="form-control form-control-lg" id="formGroupExampleInput3" value="{{i.addresses[0].line1}}" disabled>
            </div>

            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="inputCity">{{'heading.City*' | cxTranslate}}</label>
                    <input type="text" class="form-control form-control-lg" id="inputCity" disabled value="{{i.addresses[0].town}}">
                </div>
                <div class="form-group col-md-6">
                    <label for="Province">{{'heading.State/Province*' | cxTranslate}}</label>
                    <input type="text" class="form-control form-control-lg" id="Province" disabled value="{{i.addresses[0].town}}">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="Post">{{'heading.PostCode*' | cxTranslate}}</label>
                    <input type="text" class="form-control form-control-lg" id="Post" disabled value="{{i.addresses[0].postalCode}}">
                </div>
            </div>
            <div class="form-group">
                <label for="formGroupExampleInput4">{{'heading.Website' | cxTranslate}} </label>
                <input type="text" class="form-control form-control-lg" id="formGroupExampleInput4" value="{{i.website}}" #webSite [disabled]="!this.admin" (keyup)="website=webSite.value" (keyup)="disableSave()" maxlength="250">
            </div>
            <!-- 
      <div class="form-group">
        <label for="formGroupExampleInput5">{{'heading.CompanyURL1' | cxTranslate}}</label>
        <input type="text" class="form-control form-control-lg" id="formGroupExampleInput5" value="{{i.socialMediaUrl}}" #socialMediaUrl
          [disabled]="!this.admin" (keyup)="socialmediaurl=socialMediaUrl.value" (keyup)="disableSave()" required maxlength="250">
      </div> -->
            <div class="form-group">

                <button class="btn btn-block btn-primary btn-lg" type="button" *ngIf="admin" (click)="updatedate()" [disabled]="disableUser">
          {{'heading.Save' | cxTranslate}}
        </button>

                <button class="btn btn-block btn-secondary btn-lg" type="submit" *ngIf="admin" (click)="navigateToLandingPage()">
          {{'heading.Cancel' | cxTranslate}}
        </button>

                <button class="btn btn-block btn-secondary btn-lg" (click)="navigateToLandingPage()" *ngIf="!admin">
          {{'heading.Back' | cxTranslate}}
        </button>
            </div>
        </form>

    </div>